// extracted by mini-css-extract-plugin
export default {"tableWrapper":"tableWrapper--ViE2G","bookings":"bookings--Olew4","summary":"summary--ztJtB","spacer":"spacer--m9xo2","label":"label--YrT5c","amount":"amount--n_5zT"};